import {
    SURVEY_REQUESTED, SURVEY_EDIT_REQUESTED, SURVEY_UNLOAD, SURVEY_CREATE_REQUESTED, SURVEY_SUCCESS, SURVEY_FAILURE,
    SURVEY_TAGS_REQUESTED, SURVEY_TAGS_SUCCESS, SURVEY_TAGS_FAILURE,
} from '../constants';

export const requestSurvey = (id) => ({type: SURVEY_REQUESTED, payload: {id}});
export const requestEditSurvey = (id, data) => ({type: SURVEY_EDIT_REQUESTED, payload: {id, data}});
export const requestCreateSurvey = (data) => ({type: SURVEY_CREATE_REQUESTED, payload: {data}});
export const surveySuccess = (data) => ({type: SURVEY_SUCCESS, payload: {data}});
export const surveyFailure = (error) => ({type: SURVEY_FAILURE, payload: {error}});
export const unloadSurvey = () => ({type: SURVEY_UNLOAD});

export const fetchSurveyTags = (text) => ({type: SURVEY_TAGS_REQUESTED, payload: {text}});
export const fetchSurveyTagsSuccess = (tags) => ({type: SURVEY_TAGS_SUCCESS, payload: {tags}});
export const fetchSurveyTagsFailure = (error) => ({type: SURVEY_TAGS_FAILURE, payload: {error}});
